import { Permission } from '@bookora/shared';

import { usePlanLock } from '@/features/plan/plan-access';
import { registerHubSection } from '@/guidance';
import { useCan } from '@/permissions/use-can';

import { useBranchContext } from './hooks';
import { BranchesHubSection } from './hub-section';

/**
 * Side-effect module: registers «شعبه‌ها» in the «راهنما و پیشنهادها» hub
 * (order 150 — below the section tours). Imported by `branch-switcher.tsx`,
 * which the app shell always mounts, so the hub sees the same set of sections
 * on every render and calls their hooks in a stable order.
 *
 * Visible to `branch.manage` holders on a plan with branches, and to anyone
 * who actually works across several branches (the switcher is theirs).
 */
function useBranchesHubVisible(): boolean {
  const canManage = useCan(Permission.BRANCH_MANAGE);
  const lock = usePlanLock('branches');
  const { isMulti } = useBranchContext();
  return isMulti || (canManage && lock.state === 'open');
}

export const unregisterBranchesHubSection = registerHubSection({
  key: 'branches',
  order: 150,
  title: 'شعبه‌ها',
  Component: BranchesHubSection,
  useVisible: useBranchesHubVisible,
});
